import BezierEasing from 'bezier-easing';

const DEFAULT_FONT_SIZE = 16;

const getEasing = (num) => {
  const str = (num.match(/[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?/g) || []).map(n => parseFloat(n));
  return BezierEasing(str[0], str[1], str[2], str[3]);
};

const getRemBaseFontSize = () =>
  (window && Number(window.getComputedStyle(document.body).getPropertyValue('font-size').match(/\d+/)))
    ? Number(window.getComputedStyle(document.body).getPropertyValue('font-size').match(/\d+/)[0])
    : DEFAULT_FONT_SIZE;

const getDuration = duration => parseFloat(duration);

export {
  getDuration,
  getEasing,
  getRemBaseFontSize
};